module.exports = __webpack_public_path__ + "media/images/flags/4x3/bmu-458f98ec1e0b2d0019d253ec443c88b5.svg";